import React from 'react'

const Blog = () => {
    return (
        <div>
            <div class="full_width home_page_numbering"
                style={{ background: "url(/img/numbering_bg.jpg) center top" }}>
                <div class="container">
                    <div class="col-md-3  col-lg-3 col-md-3 col-sm-6 col-xs-12 mbot40">
                        <div class="number">300 <span class="plus">+</span></div><span class="txt">Certified Engineers</span>
                    </div>
                    <div class="col-md-3  col-lg-3 col-md-3 col-sm-6 col-xs-12 mbot40">
                        <div class="number">1800 <span class="plus">+</span></div><span class="txt">Worldwide Clients</span>
                    </div>
                    <div class="col-md-3  col-lg-3 col-md-3 col-sm-6 col-xs-12 mbot40">
                        <div class="number">69 <span class="plus">+</span></div><span class="txt">Quality Award Winner</span>
                    </div>
                    <div class="col-md-3  col-lg-3 col-md-3 col-sm-6 col-xs-12 mbot40">
                        <div class="number">150 <span class="plus">+</span></div><span class="txt">Total Project Running</span>
                    </div>
                </div>
            </div>
            <div class="full_wrapper padtb_95_100">
                <div class="container">
                    <h3 class="fnt_dark_color">Latest News</h3>
                    <div class="row">
                        <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12">
                            <div class="row mbot25 enitre_mouse">
                                <div class="col-lg-6 col-md-6 col-sm-4 col-xs-12">
                                    <div class="wdt_img news_img"><span class="news_Date">Dec 4, 2024</span>
                                        <div class="shadow_effect effect-apollo mbot25"><img
                                            src="/img/newlaunch1.jpg" width="370"
                                            style={{ height: '200px',width:"370px",  objectFit: 'cover' }} alt="News Img1" /></div>
                                    </div>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-8 col-xs-12">
                                    <h5 class="line_heig26 letter_spac0 mbot10 mtopminus5 fnt_black_color"><a
                                        href="news">   New Launch: Test Jig for DCU SCP & MCU Card.</a></h5>
                                    <p class="mbot10">
                                        We are excited to announce the launch of our latest
                                        automation solution</p><a href="news" class="read_more">
                                        Read More
                                    </a>
                                </div>
                            </div>
                            <div class="row mbot25 enitre_mouse">
                                <div class="col-lg-6 col-md-6 col-sm-4 col-xs-12">
                                    <div class="wdt_img news_img"><span class="news_Date">Jan 14, 2025</span>
                                        <div class="shadow_effect effect-apollo mbot25"><img
                                            src="/img/eol-dc-dc-converter.jpg" width="370"
                                         alt="News Img1"
                                            
                                            style={{ height: '200px',width:"370px",  objectFit: 'cover' }} 

                                            
                                             /></div>
                                    </div>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-8 col-xs-12">
                                    <h5 class="line_heig26 letter_spac0 mbot10 mtopminus5 fnt_black_color"><a
                                        href="news"> New Launch: End-of-Line (EOL) Testing for Electric
                                        Vehicle (EV) Motors & MCU</a></h5>
                                    <p class="mbot10">
                                        The system
                                        requires no manual intervention during testing</p><a href="news" class="read_more">
                                        Read More
                                    </a>
                                </div>
                            </div>
                            <div class="row mbot25 enitre_mouse">
                                <div class="col-lg-6 col-md-6 col-sm-4 col-xs-12">
                                    <div class="wdt_img news_img"><span class="news_Date">Aug 21, 2024</span>
                                        <div class="shadow_effect effect-apollo mbot25"><img
                                            src="/img/automation2.jpg" width="370"
                                            height="190" alt="News Img1"
                                            
                                             /></div>
                                    </div>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-8 col-xs-12">
                                    <h5 class="line_heig26 letter_spac0 mbot10 mtopminus5 fnt_black_color"><a
                                        href="/projects/Sandhar-Auto-Electric–DC-DC-Converter">  Completed EOL Test System for Sandhar Auto Electric – DC-DC Converter</a></h5>
                                    <p class="mbot10">
                                        We are pleased to announce the completion of our comprehensive test systems for Sandhar, specifically designed for EOL testing of DC-DC converters.</p><a href="/projects/Sandhar-Auto-Electric–DC-DC-Converter" class="read_more">
                                        Read More
                                    </a>
                                </div>
                            </div>
                            <div class="row mbot25 enitre_mouse">
                                <div class="col-lg-6 col-md-6 col-sm-4 col-xs-12">
                                    <div class="wdt_img news_img"><span class="news_Date">Jan 14, 2025</span>
                                        <div class="shadow_effect effect-apollo mbot25"><img
                                            src="/img/automation4.jpg" width="370"
                                            height="190" alt="News Img1" /></div>
                                    </div>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-8 col-xs-12">
                                    <h5 class="line_heig26 letter_spac0 mbot10 mtopminus5 fnt_black_color"><a
                                        href="/projects/Off-Board-Electric-Vehicle-(EV)-Chargers">  End-of-Line (EOL) Testing for Off-Board Electric Vehicle (EV) Chargers</a></h5>
                                    <p class="mbot10">
                                        End-of-Line (EOL) Testing for DC-DC Converters ensures they meet performance and quality standards before shipping</p><a href="/projects/Off-Board-Electric-Vehicle-(EV)-Chargers" class="read_more">
                                        Read More
                                    </a>
                                </div>
                            </div>
                        </div>





                        {/*Can be comment later on  */}
                        {/* <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 col_margin">
                            <div class="support_br full_width">
                                <div class="col-lg-12 support_list">
                                    <h5 class="mbot10 fnt_black_color line_heig26"><a href="/projects/EOL-DC-DC-Converter"> EOL DC-DC Converter for LG</a></h5>
                                    <p>Aug 21, 2024</p>
                                </div>
                                <div class="col-lg-12 support_list">
                                    <h5 class="mbot10 fnt_black_color line_heig26"><a href="/projects/Sandhar-Auto-Electric–DC-DC-Converter"> Completed EOL Test System for Sandhar Auto Electric – DC-DC Converter</a></h5>
                                </div>
                                <div class="col-lg-12 support_list">
                                    <h5 class="mbot10 fnt_black_color line_heig26"><a href="/projects/Off-Board-Electric-Vehicle-(EV)-Chargers"> End-of-Line (EOL) Testing for Off-Board Electric Vehicle (EV) Chargers</a></h5>
                                    <p>Sept 3, 2024</p>
                                </div>
                                <div class="col-lg-12 support_list support_read_more"><a href="/news" class="read_more">Read More News</a></div>
                            </div>
                        </div> */}
                    </div>
                </div>
            </div>
        </div>
    )
}
export default Blog
